import type { PaymentElementLayout } from '../types/StripeFeatures';
import type { CheckoutUrlRootBuilder } from './CheckoutUrlRootBuilder';

/** The on-page Stripe PaymentElement (card + alternative methods). */
export class PaymentElementPreferences {
  constructor(private readonly root: CheckoutUrlRootBuilder) {}

  layout(layout: PaymentElementLayout): this {
    this.root.param('spe_layout', layout);
    return this;
  }

  applePay(enabled = true): this {
    this.root.param('spe_apple_pay', enabled ? 'auto' : 'never');
    return this;
  }

  googlePay(enabled = true): this {
    this.root.param('spe_google_pay', enabled ? 'auto' : 'never');
    return this;
  }

  link(enabled = true): this {
    this.root.param('spe_link', enabled ? 'auto' : 'never');
    return this;
  }
}
